/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web1920102.css";

function Web1920102(props) {
  const { x47508827662_0Fb5Ab33C6_4K, option2, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-102 screen">
        <div className="overlap-group1-10">
          <img className="x47508827662_0fb5ab33c6_4k-1" src={x47508827662_0Fb5Ab33C6_4K} />
          <div className="rectangle-2-20 border-1px-dove-gray"></div>
          <div className="option-2-1 lato-bold-black-140px">{option2}</div>
          <div className="overlap-group-21">
            <div className="group-141-5">
              <div className="group-140-5">
                <div className="group-139-5">
                  <img className="group-138-5" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-5" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web1920102;
